import React, {PureComponent} from 'react';
import Image from 'app/helpers/Image';
import BuyButton from 'app/components/shop/lootboxes/buy_button';
import ShopItemDiscount from './shop_item_discount';
import {goToShopLootbox, goToShopOtherItem} from 'app/utils/app_links';
import {shopLootboxStore} from 'app/store/global';
import {translatedName} from 'app/utils/translations_helper';
import {isUSD} from 'app/utils/ShopItemPriceFormat';
import {otherItemName} from 'app/components/my_profile/artifacts/otherItemName';

const MAX_ROTATION_ANGLE = 15;
const HALF = 2;

export default class ShopItem extends PureComponent {
    state = {popupId: null};

    containerRef = React.createRef();

    componentDidMount() {
        this.setAnimationLootbox();
    }

    componentWillUnmount() {
        this.removeAnimationLootbox();
    }

    removeAnimationLootbox = () => {
        const container = this.containerRef.current;

        if (!container || !this.handleMouseMove || !this.handleMouseLeave) {
            return;
        }

        container.removeEventListener('mousemove', this.handleMouseMove);
        container.removeEventListener('mouseleave', this.handleMouseLeave);
    };

    updateTransform = ({event, container, image, animationFrameRef}) => {
        cancelAnimationFrame(animationFrameRef.id);
        animationFrameRef.id = requestAnimationFrame(() => {
            const {left, top, width, height} = container.getBoundingClientRect();
            const centerX = left + width / HALF;
            const centerY = top + height / HALF;

            const offsetX = (event.clientX - centerX) / width;
            const offsetY = (event.clientY - centerY) / height;

            const rotateY = offsetX * MAX_ROTATION_ANGLE;
            const rotateX = -offsetY * MAX_ROTATION_ANGLE;

            image.style.transform = `rotateY(${rotateY}deg) rotateX(${rotateX}deg) scale(1.05)`;
        });
    };

    resetTransform = ({image, animationFrameRef}) => {
        cancelAnimationFrame(animationFrameRef.id);
        image.style.transform = 'rotateY(0deg) rotateX(0deg) scale(1)';
    };

    setAnimationLootbox = () => {
        const container = this.containerRef.current;

        if (container) {
            const image = container.querySelector('img');
            const animationFrameRef = {id: null};
            const context = {animationFrameRef, container, image};

            this.handleMouseMove = event => this.updateTransform({event, ...context});
            this.handleMouseLeave = () => this.resetTransform(context);

            container.handleMouseMove = this.handleMouseMove;
            container.handleMouseLeave = this.handleMouseLeave;

            container.addEventListener('mousemove', this.handleMouseMove);
            container.addEventListener('mouseleave', this.handleMouseLeave);
        }
    };

    moreDetailsHandler = e => {
        e && e.preventDefault();
        const {id, recipe, currency, description, type_shop, isCasinoPage} = this.props;

        if (type_shop === 'lootbox' && recipe) {
            goToShopLootbox(recipe.slug, !isUSD(currency), isCasinoPage);
        }
        if (type_shop === 'other' && description) {
            goToShopOtherItem(id, !isUSD(currency));
        }
    };

    afterBuy = () => {
        const {recipe, type_shop, startAnimationOnNonShopPage} = this.props;

        if (type_shop === 'lootbox' && recipe) {
            shopLootboxStore.updateOpenNowStatus(true);
            startAnimationOnNonShopPage && startAnimationOnNonShopPage();
        }
        this.moreDetailsHandler();
    };

    get gameClass() {
        const {game} = this.props;

        return typeof game === 'string'
            ? (game === '' ? 'game' : 'game_') + game.toLowerCase().replace(/ |:\s*/g, '_')
            : '';
    }

    nameItem = () => {
        const {recipe, title, type_shop} = this.props;

        if (type_shop === 'lootbox') {
            return translatedName(recipe);
        }
        if (type_shop === 'other') {
            return otherItemName(this.props);
        }
        return title;
    };

    render() {
        return <div className="market__lootbox">
            <div className="market__lootbox--img-wrap">
                <div
                    className={`market__lootbox--img ${this.gameClass}`}
                    onClick={this.moreDetailsHandler}
                    ref={this.containerRef}>
                    <Image {...this.props}/>
                    <ShopItemDiscount {...this.props}/>
                </div>
            </div>
            <div className="market__lootbox--desc">
                <div className="market__lootbox--desc__content">
                    <div className="market__lootbox--title">{this.nameItem()}</div>
                </div>
                <div className="market__lootbox--actions">
                    <BuyButton
                        {...this.props}
                        afterBuy={this.afterBuy}
                        with_confirmation={true}
                        show_loading={false}
                    />
                </div>
            </div>
        </div>;
    }
}
